import React, { Component } from 'react';
import {connect} from 'react-redux'
import cn from 'classnames'
import flow from 'lodash/flow';

import withStyles from 'material-ui/styles/withStyles'
import Header from './Header'
import Menu from './Menu'
import Footer from './Footer'
import Snackbar from './Snackbar'
import {getShowHeader, getShowMenu, getShowFooter, getProfileLoaded } from '../selectors'
import ConfirmationDialog from './ConfirmationDialog'

const styles = theme => ({
    root: {
        width: '100%',
        //marginTop: theme.spacing.unit * 3,
        overflow: 'hidden',
        minHeight: '100vh',
        alignItems: 'stretch',
        display: 'flex',
        //flexDirection: 'column'
    },
    appFrame: {
        position: 'relative',
        display: 'flex',
        width: '100%',
    },
    content: {
        backgroundColor: 'white', //'#cfd8dc', //'white',//theme.palette.background.default,
        width: '100%',
        //padding: theme.spacing.unit * 3,
        minHeight: '100%',
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        '& > div': {
            flex: '1 0 auto',
            height: '100%',
        },
        '& > footer': {
            flex: '0 0 auto',
        },
        transition: theme.menu.transition('margin-left')
    },
    contentWithHeader: {
        minHeight: 'calc(100% - 56px)',
        marginTop: theme.header.heightMobile,
        [theme.breakpoints.up('sm')]: {
            minHeight: 'calc(100% - 64px)',
            marginTop: theme.header.height,
        },
    },
    contentWithMenu: {
        [theme.breakpoints.up('md')]: {
            marginLeft: 250,
        },
    }
})

class SiteFrame extends Component {

    render() {
        const {classes, children, showHeader, showMenu, showFooter} = this.props;

        return <div className={classes.root}>
                {showHeader && <Header  />}
                <div className={classes.appFrame}>
                    <Menu show={showMenu}/>
                    <main className={cn(
                        classes.content,
                        {
                            [classes.contentWithHeader]: showHeader,
                            [classes.contentWithMenu]: showMenu
                        })}>
                        <div>
                            {children}
                        </div>
                        {showFooter && <Footer />}
                    </main>
                </div>
                <Snackbar />
                <ConfirmationDialog />
        </div>
    }
};

const mapStateToProps = (state) => {
    return {
        showMenu: getShowMenu(state) && getProfileLoaded(state),
        showHeader: getShowHeader(state),
        showFooter: getShowFooter(state),
    }
}

export default flow(
    connect(mapStateToProps, null),
    withStyles(styles)
)(SiteFrame);



// WEBPACK FOOTER //
// ./src/components/SiteFrame.js